import { render, staticRenderFns } from "./BdssfReportRequirementDetail.vue?vue&type=template&id=06e6b83a&scoped=true&"
import script from "./BdssfReportRequirementDetail.vue?vue&type=script&lang=js&"
export * from "./BdssfReportRequirementDetail.vue?vue&type=script&lang=js&"
import style0 from "./BdssfReportRequirementDetail.vue?vue&type=style&index=0&id=06e6b83a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06e6b83a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VCol,VRow,VSelect})
